export default __webpack_public_path__ + "static/media/Ballroll_00088.34534abe.png";